<template>
    <el-container>
      <div class="container">
        <div class="searchBox">
          <el-form :inline="true" :model="formData">
              <el-row >
                <el-col :span="6" class="leftAlignTtem">
                  <el-form-item label="来电人员">
                    <el-input v-model="formData.caller" placeholder="请输入来电人员 模糊匹配"></el-input>
                  </el-form-item>
              </el-col>
              <el-col :span="6" class="leftAlignTtem">
                  <el-form-item label="作番号">
                    <el-input v-model="formData.zuofan" placeholder="请输入作番号 模糊匹配"></el-input>
                  </el-form-item>
              </el-col>
              <el-col :span="12" class="leftAlignTtem">
                  <el-form-item label="维修时间">

                      <el-date-picker type="date" placeholder="从" v-model="formData.fixStartDate1" ></el-date-picker>
                      <span>-</span>
                      <el-date-picker type="date" placeholder="到" v-model="formData.fixStartDate2" ></el-date-picker>

                  </el-form-item>
              </el-col>
            </el-row>
            <el-row >
                <el-col :span="6" class="leftAlignTtem">
                  <el-form-item label="故障地点">
                    <el-input v-model="formData.place" placeholder="故障地点 模糊匹配"></el-input>
                  </el-form-item>
              </el-col>
              <el-col :span="6" class="leftAlignTtem">
                  <el-form-item label="故障楼号">
                    <el-input v-model="formData.buildingNo" placeholder="故障楼号 模糊匹配"></el-input>
                  </el-form-item>
              </el-col>
              <el-col :span="12" class="leftAlignTtem">
                  <el-form-item label="维修完成时间">

                      <el-date-picker type="date" placeholder="从" v-model="formData.fixEndDate1" ></el-date-picker>
                      <span>-</span>
                      <el-date-picker type="date" placeholder="到" v-model="formData.fixEndDate2" ></el-date-picker>

                  </el-form-item>
              </el-col>
            </el-row>
            <el-row >
              <el-col :span="12" class="leftAlignTtem">
                <el-form-item label="故障类型">
                  <el-radio-group v-model="formData.type" v-removeAriaHidden>
                    <el-radio :label="0">故障维修</el-radio>
                    <el-radio :label="1">停梯维修</el-radio>
                    <el-radio :label="2">困人急修</el-radio>
                    <el-radio :label="3">其他</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="12" class="leftAlignTtem">
                <el-form-item label="维修状态">
                  <el-radio-group v-model="formData.status" v-removeAriaHidden>
                    <el-radio :label="0">停梯中</el-radio>
                    <el-radio :label="1">维修中</el-radio>
                    <el-radio :label="2">运行中</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row >
              <el-col :span="6" class="leftAlignTtem">
                  <el-form-item label="故障修理人">
                    <el-input v-model="formData.fixer" placeholder="故障修理人 模糊匹配"></el-input>
                  </el-form-item>
              </el-col>
              <el-col :span="18" class="leftAlignTtem">
                  <el-form-item label="故障原因">
                    <el-checkbox-group v-model="checkList">
                      <el-checkbox label="异物卡入"></el-checkbox>
                      <el-checkbox label="电梯蹲底"></el-checkbox>
                      <el-checkbox label="开关门故障"></el-checkbox>
                      <el-checkbox label="不当使用"></el-checkbox>
                      <el-checkbox label="地坑进水"></el-checkbox>
                      <el-checkbox label="电梯冲顶"></el-checkbox>
                      <el-checkbox label="设备仪器故障"></el-checkbox>
                  </el-checkbox-group>
                  </el-form-item>
              </el-col>
            </el-row>
            <el-row class="gapRow">
              <el-col :span="24" class="">

                  <el-button type="primary" @click="query" icon="el-icon-search"  round size="small" >查询</el-button>
                  <el-button round @click="reset" size="small">重置</el-button>
                  <el-button type="success" round @click="handleExport" size="small">导出</el-button>
                  <el-upload
                                    class="upload-demo inlineBlock margin-left"
                                    ref="upload"
                                    :action="uploadUrl"
                                    :headers="headerObj"
                                     accept=".xls,.xlsx"
                                     >
                                        <el-button  type="warning"  round size="small" >导入值班排版表</el-button>
                  </el-upload>
                  <el-button type="success" round size="small" @click="exportOverTimeInfo">导出加班信息</el-button>
                  <el-button type="success" round size="small" @click="exportDutyBonusInfo">导出值班信息</el-button>

              </el-col>
            </el-row>
          </el-form>
        </div>
        <div class="contentBox" >
          <el-table :data="tableData" max-height="2000">
            <el-table-column type="expand">
              <template slot-scope="props">
                <el-form label-position="left"  class="demo-table-expand expandForm">
                  <el-form-item label="故障原因:">
                    <span>{{ props.row.issueReason }}</span>
                  </el-form-item>
                  <el-form-item label="故障楼号:">
                    <span>{{ props.row.buildingNo }}</span>
                  </el-form-item>
                  <el-form-item label="联系电话:">
                    <span>{{ props.row.callerPhone }}</span>
                  </el-form-item>
                  <el-form-item label="维修过程:">
                    <span>{{ props.row.processDetail }}</span>
                  </el-form-item>
                  <el-form-item label="部件明细:">
                    <span>{{ props.row.parts }}</span>
                  </el-form-item>
                  <el-form-item label="维修完成时间:">
                    <span>{{ props.row.fixEndTime }}</span>
                  </el-form-item>
                </el-form>
              </template>
            </el-table-column>
            <el-table-column prop="zuofan" label="作番号" fixed></el-table-column>
            <el-table-column prop="caller" label="报修人"></el-table-column>
            <el-table-column prop="place" label="故障地点"></el-table-column>
            <el-table-column prop="type" label="故障类型"></el-table-column>
            <el-table-column prop="status" label="维修状态"></el-table-column>
            <el-table-column prop="fixer" label="处理人"></el-table-column>
            <el-table-column prop="fixStartTime" label="维修时间"></el-table-column>
            <el-table-column label="操作" fixed="right">
              <template slot-scope="scope">
                <el-row>
                  <el-col :span="24">
                      <el-button round type="success" size="small" icon="el-icon-edit" @click="handleEdit(scope.row)">编辑</el-button>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                      <el-button round type="danger" size="small" icon="el-icon-delete" @click="handleDelete(scope.row)">删除</el-button>
                   </el-col>
                </el-row>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageIndex"
      :page-sizes="[10,20,30,40,50]"
      :page-size="pageSize"
       layout="total, sizes, prev, pager, next, jumper"
      :total="total">
      </el-pagination>
      <el-drawer
          title="编辑故障建档"
          :before-close="handleClose"
          :visible.sync="dialog"
          :size="600"
          direction="ltr"
          custom-class="demo-drawer"
          ref="drawer"
          >
          <div class="demo-drawer__content">
            <el-form :model="editFormData">
              <el-form-item label="报修人:" :label-width="formLabelWidth">
                <el-input v-model="editFormData.caller" autocomplete="off" class="modelInput"></el-input>
              </el-form-item>
              <el-form-item label="作番号:" :label-width="formLabelWidth">
                <el-input v-model="editFormData.zuofan" autocomplete="off" class="modelInput"></el-input>
              </el-form-item>
              <el-form-item label="故障地点:" :label-width="formLabelWidth">
                <el-input v-model="editFormData.place" autocomplete="off" class="modelInput"></el-input>
              </el-form-item>
              <el-form-item label="故障楼号:" :label-width="formLabelWidth">
                <el-input v-model="editFormData.buildingNo" autocomplete="off" class="modelInput"></el-input>
              </el-form-item>
              <el-form-item label="故障类型:">
                  <el-radio-group v-model="editFormData.type" v-removeAriaHidden >
                    <el-radio :label="0">故障维修</el-radio>
                    <el-radio :label="1">停梯维修</el-radio>
                    <el-radio :label="2">困人急修</el-radio>
                    <el-radio :label="3">其他</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="故障原因:">

                    <el-checkbox-group v-model="editCheckList">
                      <div class="flex-checkbox">
                        <div class="flex-item">
                      <el-checkbox label="异物卡入" size="mini"></el-checkbox>
                    </div>
                    <div class="flex-item">
                      <el-checkbox label="电梯蹲底" size="mini"></el-checkbox>
                      </div>
                      <div class="flex-item">
                      <el-checkbox label="开关门故障" size="mini"></el-checkbox>
                      </div>
                      <div class="flex-item">
                      <el-checkbox label="不当使用" size="mini"></el-checkbox>
                    </div>
                    <div class="flex-item">
                      <el-checkbox label="地坑进水" size="mini"></el-checkbox>
                      </div>
                      <div class="flex-item">
                      <el-checkbox label="电梯冲顶" size="mini"></el-checkbox>
                    </div>
                      <div class="flex-item">
                      <el-checkbox label="设备仪器故障" size="mini"></el-checkbox>
                    </div>
                    </div>
                  </el-checkbox-group>
                  </el-form-item>
                  <el-form-item label="维修过程:">
                    <el-input v-model="editFormData.fixDetail" autocomplete="off" class="modelInput"></el-input>
                  </el-form-item>
                  <el-form-item label="更换配件明细:">
                    <el-button type="primary" @click="addPart" size="small">添加</el-button>
                  </el-form-item>
                  <el-form-item v-for="(item,index) in editFormData.parts" :key="index" :label="'配件'+(index+1)">
                    <el-input v-model="item.value" autocomplete="off" class="modelInput"></el-input>
                  </el-form-item>
                  <el-form-item label="维修状态:">
                    <el-radio-group v-model="editFormData.status" v-removeAriaHidden>
                    <el-radio :label="0">停梯中</el-radio>
                    <el-radio :label="1">维修中</el-radio>
                    <el-radio :label="2">运行中</el-radio>
                  </el-radio-group>
                  </el-form-item>
                  <el-form-item label="维修时间:">
                    <el-date-picker
                      v-model="editFormData.fixStartDate"
                      type="datetime"
                      placeholder="选择维修时间"
                      value-format="yyyy-MM-dd HH:mm"
                      :editable=false
                      style="margin-left:2em"
                      >
                    </el-date-picker>
                  </el-form-item >
                  <el-form-item label="维修完成时间">
                    <el-date-picker
                      v-model="editFormData.fixEndDate"
                      type="datetime"
                      placeholder="维修完成时间"
                      value-format="yyyy-MM-dd HH:mm"
                      :editable=false
                      :disabled="editFormData.status!=2"
                      ></el-date-picker>
                  </el-form-item>

            </el-form>
          </div>
          <div class="demo-drawer__footer">
              <el-button @click="cancelForm" round size="small">取 消</el-button>
              <el-button type="success" @click="submitEdit" :loading="loading" icon="el-icon-edit" round size="small">{{ loading ? '提交中 ...' : '确 定' }}</el-button>
            </div>
        </el-drawer>
        </div>
      </div>
    </el-container>
</template>

<script>
import request from '@/lib/utils'

export default {
  name: 'issues',
  data () {
    return {
      formData: {
        caller: '',
        zuofan: '',
        fixStartDate1: '',
        fixStartDate2: '',
        place: '',
        buildingNo: '',
        fixEndDate1: '',
        fixEndDate2: '',
        type: '',
        status: ''
      },
      editFormData: {
        caller: '',
        zuofan: '',
        fixStartDate: '',
        place: '',
        buildingNo: '',
        fixEndDate: '',
        type: -1,
        status: -1,
        parts: [{value: ''}],
        fixDetail: ''
      },
      checkList: [],
      editCheckList: [],
      tableData: [],
      pageIndex: 1,
      pageSize: 10,
      total: 1,
      statusLabel: ['停梯中', '维修中', '运行中'],
      typeLabel: ['故障维修', '停梯维修', '困人急修', '其他'],
      loading: false,
      dialog: false,
      timer: null,
      formLabelWidth: '80px',
      uploadUrl: process.env.API_URL + 'issue/uploadDutySchedule',
      headerObj: {
        'auth-token': ''
      }
    }
  },
  methods: {
    query () {
      const that = this
      let requestData = {
        formClass: 'IssueQuery',
        formData: ''
      }
      let formData = {}
      Object.assign(formData, that.formData)
      if (formData.status === -1 || formData.status) {
        formData.status = ''
      } else {
        formData.status = that.statusLabel[formData.status]
      }

      if (formData.type === -1 || formData.type) {
        formData.type = ''
      } else {
        formData.type = that.typeLabel[formData.type]
      }

      if (that.checkList.length > 0) {
        formData.issueReason = that.checkList.join(',')
      }
      formData.pageIndex = that.pageIndex
      formData.pageSize = that.pageSize
      requestData.formData = JSON.stringify(formData)
      request.post('/issue/queryPageForm', requestData).then(function (response) {
        console.log(response)
        that.tableData = response.obj.list
        that.total = response.obj.total
      }).catch(function (error) {
        console.log(error)
      })
    },
    reset () {
      this.formData = {
        caller: '',
        zuofan: '',
        fixStartDate1: '',
        fixStartDate2: '',
        place: '',
        buildingNo: '',
        fixEndDate1: '',
        fixEndDate2: '',
        type: ''
      }
      this.checkList = []
    },
    handleEdit (row) {
      const that = this
      request.post('/issue/queryById?id=' + row.id).then(function (response) {
        console.log(response)
        Object.assign(that.editFormData, response.obj)
        if (response.obj.type) {
          that.editFormData.type = that.typeLabel.indexOf(response.obj.type)
        }
        if (response.obj.status) {
          that.editFormData.status = that.statusLabel.indexOf(response.obj.status)
        }
        if (response.obj.fixStartTime) {
          that.editFormData.fixStartDate = response.obj.fixStartTime + ':00'
        }
        if (response.obj.fixEndTime) {
          that.editFormData.fixEndDate = response.obj.fixEndTime + ':00'
        }
        if (response.obj.issueReason) {
          that.editCheckList = response.obj.issueReason.split(',')
        }
        if (response.obj.parts) {
          let partsArray = response.obj.parts.split(',')
          that.editFormData.parts = []
          for (let part of partsArray) {
            that.editFormData.parts.push({
              value: part
            })
          }
        }
        that.dialog = true
      }).catch(function (err) {
        that.$message.error('获取数据失败 无法修改' + err)
      }

      )
    },
    handleSizeChange (cureentSize) {
      this.pageSize = cureentSize
      this.query()
    },
    handleCurrentChange (currentPage) {
      this.pageIndex = currentPage
      this.query()
    },
    handleClose () {
      const that = this
      if (that.loading) {
        return
      }
      that.$confirm('不提交 直接退出吗?')
        .then(_ => {
          that.cancelForm()
        })
        .catch(_ => {})
    },
    submitEdit () {
      const that = this
      const requestData = {
        formClass: 'MalfunctionRecord',
        formData: ''
      }
      let formData = {}
      Object.assign(formData, this.editFormData)
      if (formData.type === -1 || !formData.type) {
        formData.type = ''
      } else {
        formData.type = this.typeLabel[formData.type]
      }

      if (formData.status === -1 || !formData.status) {
        formData.status = ''
      } else {
        formData.status = this.statusLabel[formData.status]
      }
      if (this.editFormData.parts && this.editFormData.parts.length > 0) {
        formData.parts = this.editFormData.parts.filter(item => item.value).map(item => item.value).join(',')
      }
      formData.issueReason = this.editCheckList.join(',')
      if (this.editFormData.fixStartDate) {
        let fixStartDateArray = this.editFormData.fixStartDate.split(' ')
        let fixStartTimeArray = fixStartDateArray[1].split(':')
        formData.fixStartTime = fixStartDateArray[0] + 'T' + fixStartTimeArray[0] + ':' + fixStartTimeArray[1]
      }
      if (this.editFormData.fixEndDate) {
        let fixEndDateArray = this.editFormData.fixEndDate.split(' ')
        let fixEndTimeArray = fixEndDateArray[1].split(':')
        formData.fixEndTime = fixEndDateArray[0] + 'T' + fixEndTimeArray[0] + ':' + fixEndTimeArray[1]
      }
      requestData.formData = JSON.stringify(formData)
      console.log(requestData)
      request.post('/issue/updateIssue', requestData).then(
        response => {
          that.$message.success('修改成功')
          that.query()
          that.cancelForm()
        }
      ).catch(
        err => {
          that.$message.error('修改失败' + err)
        }
      )
    },
    cancelForm () {
      this.loading = false
      this.dialog = false
      clearTimeout(this.timer)
    },
    addPart () {
      this.editFormData.parts.push(
        {
          value: ''
        }
      )
    },
    handleExport () {
      let requestData = {
        formClass: 'IssueQuery',
        formData: ''
      }
      let formData = {}
      Object.assign(formData, this.formData)
      if (formData.status === -1 || formData.status) {
        formData.status = ''
      } else {
        formData.status = this.statusLabel[formData.status]
      }

      if (formData.type === -1 || formData.type) {
        formData.type = ''
      } else {
        formData.type = this.typeLabel[formData.type]
      }

      if (this.checkList.length > 0) {
        formData.issueReason = this.checkList.join(',')
      }
      formData.pageIndex = 1
      formData.pageSize = 999999999
      requestData.formData = JSON.stringify(formData)
      let requestStr = JSON.stringify(requestData)
      let exportUrl = process.env.API_URL + 'issue/exportPageForm?formData=' + encodeURIComponent(requestStr) + '&auth_token=' + localStorage.getItem('auth-token')
      window.open(exportUrl)
    },
    exportOverTimeInfo () {
      if (!this.formData.fixStartDate1 || !this.formData.fixStartDate2) {
        this.$message.error('请选择维修时间')
      } else {
        let exportUrl = process.env.API_URL + 'issue/exportOverTimeInfo?fixStartDate=' + this.formData.fixStartDate1.getTime() + '&fixEndDate=' + this.formData.fixStartDate2.getTime() + '&auth_token=' + localStorage.getItem('auth-token')
        window.open(exportUrl)
      }
    },
    exportDutyBonusInfo () {
      if (!this.formData.fixStartDate1) {
        this.$message.error('请选择维修开始时间')
      } else {
        let exportUrl = process.env.API_URL + 'issue/exportDutyBonusInfo?fixStartDate=' + this.formData.fixStartDate1.getTime() + '&auth_token=' + localStorage.getItem('auth-token')
        window.open(exportUrl)
      }
    },
    handleDelete (row) {
      this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(
        () => {
          request.get('/issue/deleteById?id=' + row.id).then(
            (res) => {
              if (res.code === 'success') {
                this.$message.success('删除成功')
              } else {
                this.$message.error('删除失败' + res.message)
              }
              this.query()
            }
          )
        }
      ).catch(
        () => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        }
      )
    }

  },
  mounted () {
    this.headerObj['auth-token'] = localStorage.getItem('auth-token')
    this.query()
  }
}

</script>

<style scoped>
 .container {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .searchBox{
    width:70% ;
    margin-top: 40px;
  }

  .leftAlignTtem{
    text-align: left;
  }

  .contentBox{
    width: 70%;
    margin-top: 50px;
  }

  .gapRow{
    margin-top: 30px;
  }

  .el-link{
    padding-right: 10px;
  }

  .modelInput{
    width:80%
  }

  .expandForm{
    margin-left: 20px;
  }

  .flex-checkbox{
    display: flex;
    flex-wrap: wrap;
    .flex-item{
      width: 25%;
      display: flex;
    }
  }

  .inlineBlock{
    display: inline-block;
  }

  .margin-left{
    margin-left:16px
  }

</style>



// WEBPACK FOOTER //
// src/page/subPage/Issues.vue